import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import "../../../Assets/styles/GISStyle.css";
import { useDispatch, useSelector } from "react-redux";
import X2JS from "x2js";
import { gisLeafletActions } from "../../../redux/slices/GIS/gis-leaflet-slice";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Tooltip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { addIco } from "../../../Assets/icons/gisIcons/icons";
import "../../../Assets/styles/GISStyle.css";
import Cookies from "js-cookie";
import { fetchData, updateData } from "../../../Utils/indexedDB";
import toast from "react-hot-toast";
const segregateAssets = (objectsArray) => {
  const Assets = [];
  objectsArray.forEach((obj) => {
    const dateMatch = obj.Name.match(/\d{2}_\d{2}_\d{4}/);
    if (dateMatch) {
      const date = dateMatch[0];
      const agpObject = { date, ...obj };
      Assets.push(agpObject);
    } else {
      Assets.push(obj);
    }
  });
  return Assets;
};

function transformLayers(layers) {
  // Helper function to format the date
  //   function formatDate(dateStr) {
  //     const dateParts = dateStr.split("-");
  //     const day = dateParts[0];
  //     const month = dateParts[1];
  //     const year = dateParts[2];

  //     const monthNames = [
  //       "January",
  //       "February",
  //       "March",
  //       "April",
  //       "May",
  //       "June",
  //       "July",
  //       "August",
  //       "September",
  //       "October",
  //       "November",
  //       "December",
  //     ];
  //     const monthName = monthNames[parseInt(month, 10) - 1];

  //     return `${day}, ${monthName} ${year}`;
  //   }

  //   // Create an object to group layers by date
  //   const groupedLayers = {};

  //   // Iterate through each layer
  //   layers.forEach((layer) => {
  //     // Extract the date from the layerName
  //     const dateMatch = layer?.layerName?.match(/\d{2}_\d{2}_\d{4}/);
  //     if (dateMatch) {
  //       const date = dateMatch[0].replace(/_/g, "-");

  //       // If the date is not in the groupedLayers object, add it
  //       if (!groupedLayers[date]) {
  //         groupedLayers[date] = [];
  //       }

  //       // Add the layer to the corresponding date group
  //       groupedLayers[date].push({
  //         layerName: layer.layerName,
  //         type: layer.layerType,
  //       });
  //     }
  //   });

  //   // Convert the groupedLayers object into the desired format
  //   const result = Object.keys(groupedLayers).map((date) => ({
  //     section: {
  //       title: formatDate(date),
  //     },
  //     assets: groupedLayers[date],
  //   }));
  //   console.log(layers, "layers");

  return layers;
}

const GeneralIndexing = ({ openAssetIndexing, mapRef }) => {
  const [assetData, setAssetData] = useState([]);
  const clientName = Cookies.get("clientName");
  const [projectData, setProjectData] = useState(null);
  const [allprojectData, setAllProjectData] = useState(null);
  const [formattedOutput, setFormattedOutput] = useState(null);

  const dispatch = useDispatch();
  const selectedAsset = useSelector((state) => state.gisLeaflet.asset);
  const showComparer = useSelector((state) => state.gisTools.showComparer);
  useEffect(() => {
    const initializeProjectData = async () => {
      try {
        const projectDataFromDB = await fetchData("project");
        setAllProjectData(projectDataFromDB);
        setProjectData(projectDataFromDB?.photogrammetryLayers);
      } catch (error) {
        // console.error("Failed to fetch project data:", error);
      }
    };

    initializeProjectData();
  }, []);

  const projectLayers = useMemo(() => projectData);
  const map = mapRef.current;

  useEffect(() => {
    const geoServerClientReferenace = "aic";

    // const wmsUrl = `https://gis.indrones.com/geoserver/${clientName}/wms`;
    // Step 1: GetLayers
    const getCapabilities = async () => {
      const response = await axios.get(
        `https://gis.indrones.com/geoserver/${geoServerClientReferenace}/wms?request=GetCapabilities`,
      );
      const x2js = new X2JS();
      const jsonObj = x2js.xml2js(response.data);
      // console.log(jsonObj, "jsonobj");
      const layers = jsonObj.WMS_Capabilities.Capability.Layer.Layer;
      const groupedData = segregateAssets(layers);
      setAssetData([]);
      setAssetData(groupedData);
      // Create the formatted output
      const excludedTimelines = ["28-29 Sep"];
      const result = createFormattedObject(groupedData, excludedTimelines);
      setFormattedOutput(result);
      // console.log(
      //   groupedData,
      //   "=raw get capabilities sorted=",
      //   result,
      //   "array",
      //   result[0].layers,
      // );
      const assetNameFirstTimeline = result[0].layers.find((asset) => {
        return asset.layerName.includes("ORTHO");
      });
      const defaultAsset = groupedData.find(
        (asset) => asset.Name === assetNameFirstTimeline.layerName,
      );
      dispatch(gisLeafletActions.setAsset(defaultAsset));
    };
    getCapabilities();
  }, []);

  // Third useEffect: Update IndexedDB when formatted data changes
  useEffect(() => {
    const updateFormattedDataInIndexedDB = async () => {
      if (formattedOutput) {
        try {
          // Update the project data object with new photogrammetryLayers
          const updatedProjectData = {
            ...allprojectData,
            photogrammetryLayers: formattedOutput,
          };

          // Update the IndexedDB with the new formatted data
          // console.log("updating DB", updatedProjectData);
          await updateData("project", 1, updatedProjectData);
          // Update the state with the new formatted data
          setProjectData(updatedProjectData.photogrammetryLayers);
        } catch (error) {
          // console.error("Failed to update project data in IndexedDB:", error);
        }
      }
    };

    updateFormattedDataInIndexedDB();
  }, [allprojectData, formattedOutput]);

  // Helper function to extract date from the Name and format it concisely
  // const extractDateRange = (name) => {
  //   const match = name.match(/AIC_(\d{1,2})-(\d{1,2})([A-Z]+)/); // Capture day, day, month
  //   if (!match) return ""; // Return empty string if no match found

  //   const [_, startDay, endDay, monthAbbr] = match; // Destructure capture groups
  //   const monthNamesShort = {
  //     JAN: "Jan",
  //     FEB: "Feb",
  //     MAR: "Mar",
  //     APR: "Apr",
  //     MAY: "May",
  //     JUN: "Jun",
  //     JUL: "Jul",
  //     AUG: "Aug",
  //     SEP: "Sep",
  //     OCT: "Oct",
  //     NOV: "Nov",
  //     DEC: "Dec",
  //   };

  //   // Convert month abbreviation to short month name
  //   const month = monthNamesShort[monthAbbr] || monthAbbr; // Fallback to abbreviation if not found

  //   // Format the date range without the year
  //   const formattedDateRange = `${startDay}-${endDay} ${month}`; // Removed the year

  //   return formattedDateRange;
  // };
  const extractDateRange = (name) => {
    // Match either format: AIC_01-02MAR or AIC_28AUG
    const match = name.match(/AIC_(\d{1,2})(?:-(\d{1,2}))?([A-Z]+)/);
    if (!match) return ""; // Return empty string if no match found

    const [_, startDay, endDay, monthAbbr] = match; // Destructure capture groups
    const monthNamesShort = {
      JAN: "Jan",
      FEB: "Feb",
      MAR: "Mar",
      APR: "Apr",
      MAY: "May",
      JUN: "Jun",
      JUL: "Jul",
      AUG: "Aug",
      SEP: "Sep",
      OCT: "Oct",
      NOV: "Nov",
      DEC: "Dec",
    };

    // Convert month abbreviation to short month name
    const month = monthNamesShort[monthAbbr] || monthAbbr; // Fallback to abbreviation if not found

    // Format the date range
    const formattedDateRange = endDay
      ? `${startDay}-${endDay} ${month}` // Handle "01-02MAR" format
      : `${startDay} ${month}`; // Handle "28AUG" format

    return formattedDateRange;
  };

  // Helper function to extract the nameToShow value
  const extractNameToShow = (name) => {
    // Check if the name matches the "AA_01" pattern and return it as-is if true
    if (/^[A-Z]{2}_\d{2}$/.test(name)) {
      return name; // Return the full name if it's in the "AA_01" format
    }
    // Check for "AIC_PHASE-2_" pattern and extract the part after "B1_" (e.g., "AIC_PHASE-2_B1-BLUE")
    if (name.startsWith("AIC_PHASE-2_")) {
      const phase2BaseName = name.replace("AIC_PHASE-2_", ""); // Remove the "AIC_PHASE-2_" prefix
      return phase2BaseName.replace(/B\d-/, ""); // Remove "B1-" or similar pattern and return "BLUE"
    }
    // Check for new "AIC_PHASE-2" pattern (Phase-2) and extract the part after it
    const phase2Match = name.match(/AIC_PHASE-2([A-Z]\d+)/);
    if (phase2Match) {
      return phase2Match[1]; // Return the part after "AIC_PHASE-2", e.g., "A1", "D1"
    }
    const baseName = name
      .replace(/AIC_\d{1,2}-\d{1,2}[A-Z]+_/, "")
      .replace(/_COG$/, "");
    // Split by underscore and get the last part
    const parts = baseName.split("_");

    // Return the last part of the name (e.g., 'B1_BLUE' -> 'BLUE', 'NDVI' -> 'NDVI')
    return parts.length > 1 ? parts[parts.length - 1] : baseName;
  };

  // Function to create the desired output format
  const createFormattedObject = (inputArray, excludedTimelines) => {
    // Create a map to group layers by their date ranges
    const groupedLayers = inputArray.reduce((acc, item) => {
      const dateRange = extractDateRange(item.Name);
      const baseName = extractNameToShow(item.Name);
      const layerType = item.Name.includes("DSM") ? "DSM" : "ORI";
      // console.log("input array", inputArray);

      // Check for new naming pattern (e.g., AA_01, AC_03) Grid-wise ORI Phase-1
      if (!dateRange && /^[A-Z]{2}_\d{2}$/.test(item.Name)) {
        // If the group for "Grid-wise ORI" doesn't exist, create it
        if (!acc["Grid-wise ORI Phase-1"]) {
          acc["Grid-wise ORI Phase-1"] = {
            nameToShow: "Grid-wise ORI Phase-1",
            layers: [],
          };
        }
        // Push the layer information into the "Grid-wise ORI" group
        acc["Grid-wise ORI Phase-1"].layers.push({
          layerName: item.Name,
          layerType: layerType,
          nameToShow: baseName,
        });

        return acc;
      }
      // Check for new "AIC_PHASE-2" pattern for Complete ORI Phase-2 AIC_PHASE-2_B1-BLUE
      if (!dateRange && item.Name.startsWith("AIC_PHASE-2_")) {
        // If the group for "Complete ORI Phase-2" doesn't exist, create it
        if (!acc["Complete ORI Phase-2"]) {
          acc["Complete ORI Phase-2"] = {
            nameToShow: "Complete ORI Phase-2",
            layers: [],
          };
        }
        // Push the layer information into the "Complete ORI Phase-2" group
        acc["Complete ORI Phase-2"].layers.push({
          layerName: item.Name,
          layerType: layerType,
          nameToShow: baseName, // baseName could be like "B1-BLUE" from "AIC_PHASE-2_B1-BLUE"
        });

        return acc;
      }
      // Check for new "AIC_PHASE-2" pattern for Grid-wise ORI Phase-2 :AIC_PHASE-2A1
      if (!dateRange && item.Name.startsWith("AIC_PHASE-2")) {
        if (!acc["Grid-wise ORI Phase-2"]) {
          acc["Grid-wise ORI Phase-2"] = {
            nameToShow: "Grid-wise ORI Phase-2",
            layers: [],
          };
        }
        acc["Grid-wise ORI Phase-2"].layers.push({
          layerName: item.Name,
          layerType: layerType,
          nameToShow: baseName,
        });

        return acc;
      }
      // If date range is empty and the name matches the "AIC_name" format :AIC_B1_BLUE
      if (!dateRange && item.Name.startsWith("AIC_")) {
        // If the group for "Complete ORI" doesn't exist, create it
        if (!acc["Complete ORI Phase-1"]) {
          acc["Complete ORI Phase-1"] = {
            nameToShow: "Complete ORI Phase-1",
            layers: [],
          };
        }
        // Push the layer information into the "Complete ORI" group
        acc["Complete ORI Phase-1"].layers.push({
          layerName: item.Name,
          layerType: layerType,
          nameToShow: baseName,
        });

        return acc;
      }
      // If date range is empty or excluded timelines, skip this item
      if (!dateRange || excludedTimelines.includes(dateRange)) {
        return acc; // Skip this item if dateRange is empty or excluded
      }

      // If the date range group doesn't exist, create it
      if (!acc[dateRange]) {
        acc[dateRange] = {
          nameToShow: dateRange,
          layers: [],
        };
      }

      // Push the layer information into the appropriate group
      acc[dateRange].layers.push({
        layerName: item.Name,
        layerType: layerType,
        nameToShow: baseName,
      });

      return acc;
    }, {});

    // Convert the groupedLayers object into an array
    const groupedLayersArray = Object.values(groupedLayers);

    // Sort the array based on the date range (month and day) in ascending order
    groupedLayersArray.sort((a, b) => {
      // Define the desired order of the group names (higher numbers come after)
      const order = {
        "Grid-wise ORI Phase-1": 5,
        "Grid-wise ORI Phase-2": 6,
        "Complete ORI Phase-1": 7,
        "Complete ORI Phase-2": 8,
      };

      // Check if both items are predefined groups
      const isAGroup = order[a.nameToShow] !== undefined;
      const isBGroup = order[b.nameToShow] !== undefined;

      // If both items are from defined groups, sort by the predefined order
      if (isAGroup && isBGroup) {
        return order[a.nameToShow] - order[b.nameToShow];
      }

      // If one is from a group and the other is not, date-based (non-group) comes first
      if (isAGroup) return 1; // `a` is a group, so it should come after date-based
      if (isBGroup) return -1; // `b` is a group, so it should come after date-based

      // Split into days and month
      const [daysA, monthA] = a.nameToShow.split(" ");
      const [daysB, monthB] = b.nameToShow.split(" ");

      // Split days into start and end days
      const [startDayA, endDayA] = daysA.split("-").map(Number);
      const [startDayB, endDayB] = daysB.split("-").map(Number);

      const monthIndex = {
        Jan: 1,
        Feb: 2,
        Mar: 3,
        Apr: 4,
        May: 5,
        Jun: 6,
        Jul: 7,
        Aug: 8,
        Sep: 9,
        Oct: 10,
        Nov: 11,
        Dec: 12,
      };

      // Get month indices for comparison
      const monthAIndex = monthIndex[monthA];
      const monthBIndex = monthIndex[monthB];

      // Compare months first
      if (monthAIndex !== monthBIndex) {
        return monthAIndex - monthBIndex; // Sort by month in ascending order
      }

      // If months are the same, compare start days in ascending order
      return startDayA - startDayB; // Sort by start day if months are equal
    });

    return groupedLayersArray;
  };

  /**
   * function to index the retrived data form the geoserver
   * @param {Array[]} originalData
   */
  function convertMixedData(originalData) {
    const formattedData = [];

    // Group data by date
    const groupedData = originalData.reduce((acc, entry) => {
      const date = entry.split("_")[2];
      acc[date] = acc[date] || [];
      acc[date].push(entry);
      return acc;
    }, {});

    // Process each date group
    Object.keys(groupedData).forEach((date) => {
      const entries = groupedData[date];
      const sections = {};

      // Organize entries into sections by start chainage
      entries.forEach((entry) => {
        const parts = entry.split("_");
        const startChainage = parseFloat(parts[3]);
        sections[startChainage] = sections[startChainage] || [];
        sections[startChainage].push(entry);
      });

      // Convert sections to formatted data and sort them by start chainage
      Object.keys(sections)
        .sort((a, b) => parseFloat(a) - parseFloat(b)) // Sort sections by start chainage
        .forEach((startChainage) => {
          const entriesInSection = sections[startChainage];
          const endChainage = parseFloat(entriesInSection[0].split("_")[5]);
          const title = `${startChainage}km to ${endChainage}km`;
          const section = {
            startChainage,
            endChainage,
            title,
          };
          const assets = entriesInSection.map((entry) => ({
            id: entry,
            type: entry.startsWith("HMEL_DSM") ? "DSM" : "ORI",
          }));
          formattedData.push({ section, assets });
        });
    });

    return formattedData;
  }

  const logNames = (assetData) => {
    // console.log(assetData);
    let assetNameArry = assetData.map((asset) => asset.Name);
    // console.log(assetNameArry);
    return assetNameArry;
  };

  const dataToPass = logNames(assetData);
  // const formattedData = convertMixedData(dataToPass);

  const selectedAssetEquals = (assetTitle) => {
    if (assetTitle !== selectedAsset?.Title) {
      return false;
    } else if (selectedAsset?.Title === undefined) {
      return false;
    } else {
      return true;
    }
  };

  useEffect(() => {
    // eslint-disable-next-line array-callback-return
    dataToPass?.map((asset) => {
      asset !== null &&
        dispatch(gisLeafletActions.setAvaliableRasterAssets(asset));
    });
  }, [assetData]);
  return (
    <div
      className={`${
        openAssetIndexing ? "block" : "hidden"
      } relative mb-2 ml-2 mr-2 mt-2 min-w-[18rem] !grow overflow-x-hidden rounded-tl-md rounded-tr-md border-[1px] border-solid border-[#d7d8d8] bg-[#fff]`}
    >
      <div className="flex w-full items-center rounded-tl-[1px] rounded-tr-[1px] bg-[#ffca0094] pb-[10px] pt-[10px] font-[500]">
        <div className="flex grow items-center justify-center">Assets</div>
      </div>
      <div className="overflow-x-hidden">
        {projectLayers?.layers ? (
          <Accordion className={`!my-0 !p-0 text-sm shadow-none`}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
              className="!m-0 flex min-h-max !items-center !justify-center"
            >
              <p className="text-sm"> {projectLayers?.nameToShow}</p>
            </AccordionSummary>
            {projectLayers.layers.map((layer, index) => (
              <AccordionDetails key={index} className="!m-0 w-full grow !p-2">
                {/* {asset.assets.map((asset, index) => ( */}
                <Tooltip placement="right" key={index} title={"Click to add "}>
                  <div
                    className={`my-2 flex grow items-center rounded-md py-1 hover:bg-[#ffea00b4] ${
                      selectedAsset?.Name === layer?.layerName
                        ? "bg-[#ecfc61]"
                        : showComparer === true
                          ? "bg-white"
                          : ""
                    }`}
                    key={index}
                  >
                    <div
                      className={`flex w-full cursor-pointer items-center justify-between px-2 pr-[10px]`}
                      onClick={() => {
                        // console.log("layer",layer);
                        const assetToSet = assetData.find(
                          (item) => item?.Name === layer.layerName,
                        );
                        // console.log(assetToSet,"assetToSet");
                        if (assetToSet) {
                          dispatch(gisLeafletActions.setAsset(assetToSet));
                          const {
                            westBoundLongitude,
                            eastBoundLongitude,
                            northBoundLatitude,
                            southBoundLatitude,
                          } = assetToSet?.EX_GeographicBoundingBox;

                          // Create Leaflet LatLngBounds object
                          const southWest = [
                            parseFloat(southBoundLatitude),
                            parseFloat(westBoundLongitude),
                          ];
                          const northEast = [
                            parseFloat(northBoundLatitude),
                            parseFloat(eastBoundLongitude),
                          ];
                          const bounds = [southWest, northEast];

                          // Fit the map to the bounds
                          map.fitBounds(bounds);
                        } else {
                          toast.error("Opps! Data not found");
                        }
                      }}
                    >
                      <p
                        className={`pl-4 text-sm ${
                          selectedAsset?.Name === layer.layerName
                            ? null
                            : "border-l-2"
                        }`}
                      >
                        {layer?.nameToShow}
                      </p>
                      <span className="text-xs"></span>

                      <img
                        src={addIco}
                        className="my-auto h-5 rounded-full border-2 border-[#808080]"
                        alt=""
                        srcSet=""
                      />
                    </div>
                  </div>
                </Tooltip>
                {/* ))} */}
              </AccordionDetails>
            ))}
          </Accordion>
        ) : (
          transformLayers(projectLayers)?.map((asset, index) => {
            // console.log(asset);
            return (
              <Accordion
                key={asset + index}
                className={`!my-0 !p-0 text-sm shadow-none`}
              >
                <AccordionSummary
                  key={asset + index}
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                  className="!m-0 flex min-h-max !items-center !justify-center"
                >
                  <p className="text-sm">{asset?.nameToShow}</p>
                </AccordionSummary>
                {asset.layers.map((layer, index) => (
                  <AccordionDetails
                    className="!m-0 w-full grow !p-2"
                    key={layer + index}
                  >
                    {/* {asset.assets.map((asset, index) => ( */}
                    <Tooltip
                      placement="right"
                      key={asset?.id + index}
                      title={"Click to add "}
                    >
                      <div
                        className={`my-2 flex grow items-center rounded-md py-1 hover:bg-[#ffea00b4] ${
                          selectedAsset?.Name === layer?.layerName
                            ? "bg-[#ecfc61]"
                            : showComparer === true
                              ? "bg-white"
                              : ""
                        }`}
                        key={index}
                      >
                        <div
                          className={`flex w-full cursor-pointer items-center justify-between px-2 pr-[10px]`}
                          onClick={() => {
                            const assetToSet = assetData.find(
                              (item) => item?.Name === layer.layerName,
                            );
                            // console.log(assetToSet,"asset to set");
                            dispatch(gisLeafletActions.setAsset(assetToSet));
                            //code to fly to layer
                            const {
                              westBoundLongitude,
                              eastBoundLongitude,
                              northBoundLatitude,
                              southBoundLatitude,
                            } = assetToSet?.EX_GeographicBoundingBox;
                            // Create Leaflet LatLngBounds object
                            const southWest = [
                              parseFloat(southBoundLatitude),
                              parseFloat(westBoundLongitude),
                            ];
                            const northEast = [
                              parseFloat(northBoundLatitude),
                              parseFloat(eastBoundLongitude),
                            ];
                            const bounds = [southWest, northEast];
                            // Fit the map to the bounds
                            // map.fitBounds(bounds);
                          }}
                        >
                          <p
                            className={`pl-4 text-sm ${
                              selectedAsset?.Name === layer.layerName
                                ? null
                                : "border-l-2"
                            }`}
                          >
                            {layer?.nameToShow}
                          </p>
                          <span className="text-xs"></span>

                          <img
                            src={addIco}
                            className="my-auto h-5 rounded-full border-2 border-[#808080]"
                            alt=""
                            srcSet=""
                          />
                        </div>
                      </div>
                    </Tooltip>
                    {/* ))} */}
                  </AccordionDetails>
                ))}
              </Accordion>
            );
          })
        )}
      </div>
    </div>
  );
};

export default GeneralIndexing;
